import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

export type GetNodeOrganizationsRequest = paths['/organizations']['get']['parameters']['query'];
type GetNodeOrganizationsDataObject =
  paths['/organizations']['get']['responses']['default']['content']['application/json'];

export const getNodeOrganizations = async ({ config }: ConfigRequest<GetNodeOrganizationsRequest>) =>
  nodeApiClient.get<GetNodeOrganizationsDataObject, ApiClientResponse<GetNodeOrganizationsDataObject>>(
    nodeApiRoutes.organizations.find,
    config,
  );
